import { FC } from 'react';

import { mapToBadge } from '@telialt/core-eshop/src/product/ProductVariationBadges/mapToBadge';
import { BadgeBlockInfoProps } from '@telialt/core-eshop/src/product/ProductVariationBadges/model';
import { ProductVariationBadgesMemo } from '@telialt/core-eshop/src/product/ProductVariationBadges/ProductVariationBadges';

import { getFirstProductVariation } from '../../utils';
import { useRetailsContext } from '../RetailsContext';
import { RetailVariantBadgeBlock } from './RetailVariantBadgeBlock';
import { RetailsVariantBadgeBlockTitle } from './RetailVariantBadgeBlockTitle';

const RetailVariantBadgeBlockInfo: FC<BadgeBlockInfoProps> = () => {
    return null;
};

export const VariantSelector: FC = () => {
    const { baseProductCode, data, updateVariantFilter, isHiddenFromScreenReader } = useRetailsContext();

    if (!baseProductCode) {
        return null;
    }

    const variantMatrix = data?.variantMatrix;
    const productVariantCode = getFirstProductVariation(variantMatrix)?.code;

    if (!data || !variantMatrix || !productVariantCode) {
        return null;
    }

    return (
        <ProductVariationBadgesMemo
            variantMatrix={variantMatrix}
            productInCartCode={productVariantCode}
            onSelect={updateVariantFilter}
            mapToBadge={mapToBadge}
            BadgeBlockTitle={RetailsVariantBadgeBlockTitle}
            BadgeBlockContent={RetailVariantBadgeBlock}
            BadgeBlockInfo={RetailVariantBadgeBlockInfo}
            isDisabled={isHiddenFromScreenReader}
        />
    );
};
